export const circlePacking = {
    layoutPadding: 5,
    circlePacking: {
        visible: !0,
        style: {
            cursor: "pointer",
            lineWidth: 1,
            stroke: {
                type: "palette",
                key: "backgroundColor"
            }
        }
    },
    label: {
        visible: !0,
        style: {
            cursor: "pointer",
            fill: "black",
            stroke: {
                type: "palette",
                key: "backgroundColor"
            },
            lineWidth: 2,
            fontSize: {
                type: "token",
                key: "l5FontSize"
            },
            lineHeight: {
                type: "token",
                key: "l5LineHeight"
            }
        }
    }
};
//# sourceMappingURL=circle-packing.js.map
